import { SYSTEM_COLLAPSE, SYSTEM_EXPAND, USER_COLLAPSE } from 'common/actions/row-groups/types';
import { EQUITY_ALLOCATION_KEY } from 'pages/ValuationsAllocation/common/constants/equityAllocation';
import { InvalidCellEntry } from 'pages/ValuationsAllocation/types';
import { isEquityAllocationSheet } from 'pages/ValuationsAllocation/util/getInvalidTables';
import { RowGroupsBySheet } from './types';

const COLLAPSED_STATES: string[] = [SYSTEM_COLLAPSE, USER_COLLAPSE];

// Related-entity Equity Allocation copies share the main sheet's row groups.
const expandInvalidCellRowGroups = (
  { rowGroups, sheetName }: Pick<InvalidCellEntry, 'rowGroups' | 'sheetName'>,
  rowGroupsBySheet: RowGroupsBySheet
) => {
  const owner = rowGroupsBySheet[isEquityAllocationSheet(sheetName) ? EQUITY_ALLOCATION_KEY : sheetName];
  if (!owner) {
    return;
  }
  rowGroups
    .filter(row => COLLAPSED_STATES.includes(owner.rowGroups[row]))
    .forEach(row => owner.setRowGroups({ reason: 'invalid-save', row, type: SYSTEM_EXPAND }));
};

export default expandInvalidCellRowGroups;
